import { configureStore } from "@reduxjs/toolkit";
import user_auth_slice from "./slices/user_auth_slice";
import ui_control_slice from "./slices/ui_control_slice";
import layoutControler from "./slices/layoutControler";
import services_manage_slice from "./slices/services_slice";
import chat_manage_slice from "./slices/chat_slice";
import subscription_slice from "./slices/subscription_slice";
import support_ticket_slice from "./slices/support_ticket_slice";



export const store = configureStore({
    reducer: {
        userAuth: user_auth_slice,
        uiControle: ui_control_slice,
        layout_controler: layoutControler,
        serviceManage: services_manage_slice,
        chatManage: chat_manage_slice,
        subscriptionSlice: subscription_slice,
        supportTickets: support_ticket_slice,
    },
});
export default store;
